import React from 'react'
import type { SvgIconProps } from '@material-ui/core/SvgIcon'
import SvgIcon from '@material-ui/core/SvgIcon'

const AdditionalWorkIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox={'0 0 16 16'} fill="none" {...props}>
    <path
      d="M3.99999 14.6667C3.64637 14.6667 3.30723 14.5262 3.05718 14.2761C2.80713 14.0261 2.66666 13.687 2.66666 13.3333V2.66666C2.66666 2.31304 2.80713 1.9739 3.05718 1.72385C3.30723 1.47381 3.64637 1.33333 3.99999 1.33333H9.33332C9.54436 1.33299 9.75338 1.3744 9.94834 1.45518C10.1433 1.53595 10.3204 1.6545 10.4693 1.804L12.8613 4.196C13.0112 4.345 13.1301 4.52223 13.2111 4.71744C13.2921 4.91265 13.3337 5.12198 13.3333 5.33333V13.3333C13.3333 13.687 13.1928 14.0261 12.9428 14.2761C12.6927 14.5262 12.3536 14.6667 12 14.6667H3.99999Z"
      fill="none"
      stroke="#6C757D"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33334 1.33333V4.66666C9.33334 4.84347 9.40358 5.01304 9.52861 5.13807C9.65363 5.26309 9.8232 5.33333 10 5.33333H13.3333"
      fill="none"
      stroke="#6C757D"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 10L7.33333 11.3333L10 8.66667"
      fill="none"
      stroke="#6C757D"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
)
export default AdditionalWorkIcon
